<template>
  <div class="ui segment">
    <h4 class="ui header">Quote</h4>
    <div class="ui two cards">
      <div v-for="(quote, index) in reservation.quote.quotes" v-bind:class="{ dimmed: selected != null && index != selected }" class="ui card" :key="index">
          <div class="image">
            <img v-on:click="selectReservation(quote, index)" :src="getImageUrl(quote.vehicleName)">
          </div>
          <div class="content center aligned">
            <p class="header">{{ quote.vehicleName }}</p>
            <i class="user icon"></i> {{ quote.maxPassengers }} &nbsp&nbsp&nbsp|&nbsp&nbsp&nbsp <i class="suitcase icon"></i> {{ quote.maxPassengers }}
            <div class="meta">
              {{ quote.vehicleDescription }}
            </div>
            <h2 class="ui center aligned">
              {{ formatDollars(getBaseFareFromFare(getAirportFareFromQuote(quote)).lineItemCost) }}
            </h2>
            <p class="ui center aligned">
              <a v-on:click="showModal('quote-' + index)">+ Fees <i class="info circle icon"></i></a>
            </p>
          </div>
          <div class="extra content">
            <div v-if="selected != null">
              <div v-if="selected == index">
                <button v-on:click="selectReservation(quote, index)" class="fluid ui green button">Selected</button>
              </div>
              <div v-else>
                <button v-on:click="selectReservation(quote, index)" class="fluid ui button">Select Vehicle</button>
              </div>
            </div>
            <div v-else>
             <button v-on:click="selectReservation(quote, index)" class="fluid ui blue button">Select Vehicle</button>
            </div>
          </div>

          <div class="ui modal" v-bind:id="'quote-' + index">
            <div class="header">{{ quote.vehicleName }}</div>
            <div class="content">
              <CostTable v-bind:showFeeInfo="true" v-bind:fareLineItems="quote.fares[0].fareLineItems"></CostTable>
            </div>
            <div class="actions">
              <div class="ui approve button">OK</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { textUtil } from './mixins/textUtil.js'
  import CostTable from './CostTable.vue'

  export default {
    name: 'Quote',
    props: {
      reservation: Object
    },
    components: { CostTable },
    mixins: [ textUtil ],
    data: function () {
      return {
        selected: null,
        date: '',
        time: '',
        dateTime: '',
        complete: false
      }
    },
    methods: {
      getImageUrl: function (vehType) {
        if (vehType === 'Executive Sedan') {
          return '/static/luxury-sedan.jpg'
        } else if (vehType === 'Executive SUV') {
          return '/static/luxury-suv.jpg'
        }
      },
      selectReservation: function (value, index) {
        this.selected = index
        this.$emit('selectReservation', value)
      },
      getAirportFareFromQuote: function (quote) {
        return quote.fares.find((fare) => {
          return fare.fareProfile === 'airport'
        })
      },
      getPointToPointFareFromQuote: function (quote) {
        return quote.fares.find((fare) => {
          return fare.fareProfile === 'pointtopoint'
        })
      },
      getBaseFareFromFare: function (fare) {
        return fare.fareLineItems.find((lineItem) => {
          return lineItem.lineItemType === 'fare'
        })
      },
      showModal: function (modalId) {
        $('#' + modalId)
          .modal('show')
      }
    }
  }
</script>

<style>
  .card.dimmed {
    opacity: 0.5
  }
</style>


// WEBPACK FOOTER //
// src/components/Quote.vue